import { Injectable } from '@angular/core';
import { TileMultiStateSensorsComponent } from '../../../components/tile/tile-multi-state-sensors/tile-multi-state-sensors';
import type { SystemDefaultTile } from '../../../interfaces/system-default-tile.interface';
import type { CoreSystemWithSensors } from '../../../interfaces/System.interface';
import type { CustomTileModel, MultiStateTileDescriptionData, MultiTileModel } from '../../../interfaces/Tile.interface';
import type { CustomTileProvider } from './custom-tile.provider';

@Injectable({
    providedIn: 'root'
})
export class TileMultiStateSensorsProvider implements CustomTileProvider {
    fillTileDescription(
        tileDescription: MultiTileModel,
        defaultTile: SystemDefaultTile<MultiStateTileDescriptionData>,
        system: CoreSystemWithSensors
    ): CustomTileModel {
        const customTileModel: MultiTileModel = {
            ...tileDescription,
            sensors: defaultTile.tileParams.sensors
                .filter(sensor => {
                    const coreSystemSensor = system.sensors.find(s => s.sensorId === sensor.sensorIdentifier.sensorId);
                    if (!coreSystemSensor) return false;
                    return coreSystemSensor.isActive === null || coreSystemSensor.isActive === true;
                })
                .map(sensorDesc => ({
                    ...sensorDesc,
                    sensorIdentifier: {
                        sensorId: sensorDesc.sensorIdentifier.sensorId,
                        systemId: system.systemId
                    }
                }))
        };
        return customTileModel;
    }

    getTileComponent() {
        return TileMultiStateSensorsComponent;
    }
}
